import type { IconData } from '@stacksjs/iconify-core'

export const locationPinDisabled: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M36.586 35.146C39.617 31.253 42 26.457 42 21c0-9.941-8.059-18-18-18a17.96 17.96 0 0 0-13.5 6.094M7.412 14A17.9 17.9 0 0 0 6 21c0 12.919 13.35 22.128 17.056 24.436c.587.365 1.31.36 1.896-.005a49.6 49.6 0 0 0 7.657-5.931\"/><path d=\"M28.79 27.407A8 8 0 1 0 17.755 16M23.5 28.985a8 8 0 0 1-7.485-7.485M4 3l42 42\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default locationPinDisabled
